import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./Ranking.scss";

import wantedSign from "../../assets/images/wanted-2.webp";
import avatar1 from "../../assets/images/avatar/avatar1.webp";
import avatar2 from "../../assets/images/avatar/avatar2.webp";
import avatar3 from "../../assets/images/avatar/avatar3.webp";
import avatar4 from "../../assets/images/avatar/avatar4.webp";
import avatar5 from "../../assets/images/avatar/avatar5.webp";
import avatar6 from "../../assets/images/avatar/avatar6.webp";
import avatar7 from "../../assets/images/avatar/avatar7.webp";
import avatar8 from "../../assets/images/avatar/avatar8.webp";
import avatar9 from "../../assets/images/avatar/avatar9.webp";
import avatar10 from "../../assets/images/avatar/avatar10.webp";
import avatar11 from "../../assets/images/avatar/avatar11.webp";
import avatar12 from "../../assets/images/avatar/avatar12.webp";
import avatar13 from "../../assets/images/avatar/avatar13.webp";
import avatar14 from "../../assets/images/avatar/avatar14.webp";
import avatar15 from "../../assets/images/avatar/avatar15.webp";
import avatar16 from "../../assets/images/avatar/avatar16.webp";
import avatar17 from "../../assets/images/avatar/avatar17.webp";
import avatar18 from "../../assets/images/avatar/avatar18.webp";
import avatar19 from "../../assets/images/avatar/avatar19.webp";
import avatar20 from "../../assets/images/avatar/avatar20.webp";
import avatar21 from "../../assets/images/avatar/avatar21.webp";
import avatar22 from "../../assets/images/avatar/avatar22.webp";
import avatar23 from "../../assets/images/avatar/avatar23.webp";
import avatar24 from "../../assets/images/avatar/avatar24.webp";

import { fetchRanking } from "../../redux/actions/ranking";
import { getBalance } from "../../redux/actions/session";

import Menu from "../../components/menuDesktop/MenuDesktop";
import MobileMenu from "../../components/menuMobile/MenuMobile";
import WhatsAppButton from "../../components/whatsAppButton/WhatsAppButton";

const avatars = [
  avatar1, avatar2, avatar3, avatar4, avatar5, avatar6,
  avatar7, avatar8, avatar9, avatar10, avatar11, avatar12,
  avatar13, avatar14, avatar15, avatar16, avatar17, avatar18,
  avatar19, avatar20, avatar21, avatar22, avatar23, avatar24,
];

const getAvatar = (index) => avatars[index % avatars.length];

const Ranking = () => {
  const dispatch = useDispatch();
  const ranking = useSelector((state) => state.ranking);

  useEffect(() => {
    dispatch(fetchRanking());
    dispatch(getBalance());
  }, [dispatch]);

  const players = (ranking && ranking.players) || [];

  return (
    <>
      <Menu />

      <div className="ranking-page">
        <header className="ranking-page__title">
          <h1>Ranking</h1>
          <p>Acompanhe a evolução dos jogadores</p>
        </header>

        <div className="ranking-page__banner">
          <img src={wantedSign} alt="Wanted" />
        </div>

        <div className="ranking-page__table">
          <div className="ranking-page__head">
            <span className="ranking-page__head-rank">Rank</span>
            <span className="ranking-page__head-player">Jogador</span>
            <span className="ranking-page__head-points">Pontos</span>
          </div>

          <ul className="ranking-list">
            {players.map((player, index) => {
              const pos = index + 1;
              return (
                <li
                  key={`${player.nickname}-${index}`}
                  className={`ranking-row ${
                    index % 2 === 1 ? "ranking-row--alt" : ""
                  }`}
                >
                  <span className="ranking-row__pos">{pos}</span>

                  <div className="ranking-row__player">
                    <img
                      className="ranking-row__avatar"
                      src={getAvatar(index)}
                      alt={player.nickname}
                    />
                    <span className="ranking-row__name">
                      {player.nickname}
                    </span>
                  </div>

                  <span className="ranking-row__points">
                    <i className="fa-solid fa-arrow-right" />
                    <span>{player.points}</span>
                  </span>
                </li>
              );
            })}
          </ul>
        </div>
      </div>

      <WhatsAppButton />
      <MobileMenu />
    </>
  );
};

export default Ranking;
